/**
 * La durée d'un enregistrement ou d'une prise : « 48 s », « 4 min 12 », « 1 h 05 ».
 *
 * Les secondes restent visibles sous l'heure — un essai dure des minutes, et
 * deux prises de « 4 min » qu'on ne peut pas distinguer ne servent à rien. Au
 * delà de l'heure elles disparaissent : personne ne choisit entre deux récitals
 * d'une heure à la seconde près, et « 1 h 05 min 12 » se lit deux fois.
 *
 * Extrait de `recital-hall.tsx`, où il est né pour les prises du replay, le
 * jour où « Mes enregistrements » a eu besoin exactement du même. Deux copies
 * auraient donné deux façons d'écrire la même durée sur deux écrans qui se
 * suivent.
 *
 * Module pur : ni React, ni DOM.
 */
export function recordingLength(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const seconds = total % 60;
  const minutes = Math.floor(total / 60) % 60;
  const hours = Math.floor(total / 3600);

  if (hours > 0) {
    return `${hours} h ${String(minutes).padStart(2, "0")}`;
  }

  if (minutes > 0) {
    return `${minutes} min ${String(seconds).padStart(2, "0")}`;
  }

  return `${seconds} s`;
}
